const launchScoreboard = (container, sport) => {
  if (!window.WH.sportsbook) {
    window.WH.sportsbook = {};
  }
  if (typeof window.WH.ScoreboardIntegration !== 'undefined') {
    window.WH.sportsbook.sport = sport;
    window.WH.sportsbook.scoreboard = new window.WH.ScoreboardIntegration(container);
  }
};

export default launchScoreboard;
